import React from 'react';

import MenuContainer from 'menus/containers/MenuContainer';
import EditCartItemRoute from 'cart/containers/EditCartItemRoute';
import { isMobileMedia } from 'utils/media';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

/**
 * This EditCartItemRouteContainer will render the MenuItemDetail component
 * user wants to edit a cart item when they are on the menus page. The MenuContainer
 * will render as the background, with the MenuItemDetail as foreground.
 */
class EditCartItemRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <EditCartItemRoute />;
    }

    return <MenuContainer shouldOpenEditCartItemModal />;
  }
}

export default withGoogleLibraryLoaded(EditCartItemRouteContainer);
